import axios from 'axios';
export default class MemberService {
    async GetStatisticList(data) {
        return await axios .post('api/v1/admin/member-statistic/list', data);
    }
    // async addNotice(title, description, create_date) {
    //     return await axios
    //         .post(`api/v1/admin/notice/add`, {
    //             title: title,
    //             description: description,
    //             create_date: create_date,
    //         })
    //         .then((res) => res);
    // }
    async viewPurchase(ids) {
        return await axios
            .post(`api/v1/admin/purchase/detail-purchase`, {
                purchase_id: ids,
            })
            .then((res) => res.data.result);
    }
    async UpdatePurchase(data) {
        return await axios
            .post(`api/v1/admin/purchase/update-purchase`, data)
            .then((res) => res);
    }
}
